import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import TablesSettings from '~Scenes/Settings-v2/Scenes/Tables';
import { useI18n } from '~Hooks';

/** Handheld shell around the shared Settings-v2 tables scene */
const Page = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Settings.Tables')}>
      <TablesSettings isHandy />
    </HandyPageWrapper>
  );
};

export default Page;
